import { CONSTS } from 'config/objectConst'
import { wrapExistProxy } from 'shared/utils'

export const typeToCN = wrapExistProxy(
	{
		[CONSTS.AVAILABLE_ACTIONS.Connect.Type]: 'connect',
		[CONSTS.AVAILABLE_ACTIONS.EndorseSkill.Type]: 'endorse-a-skill',
		[CONSTS.AVAILABLE_ACTIONS.Follow.Type]: 'follow',
		[CONSTS.AVAILABLE_ACTIONS.Message.Type]: 'message',
		[CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Type]: 'like-a-post',
		[CONSTS.AVAILABLE_ACTIONS.ScrapeProfile.Type]: 'scrape-profile',
		[CONSTS.AVAILABLE_ACTIONS.VisitProfile.Type]: 'view-profile'
	},
	'Not supported action type'
)
